interface IAppConst {
  headerHeight: number;
  baseApiURL: string;
  OIDC_AUTHORITY: string;
  OIDC_LOGOUT: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;
  OIDC_CLIENT_SECRET: string;
  OIDC_SCOPE: string;
  OIDC_UNIT: string;
  LOGO: string;
  NAME_UNIT: string;
  GOV_NAME: string;
  MAU_BIEN_LAI_SINH_VIEN: string;
  MAU_BIEN_LAI_SINH_VIEN_NHAP_HOC: string;
  MAU_BIEN_LAI_THI_SINH_TUYEN_SINH: string;
  MENU_PHAN_QUYEN: string;
  THEME: string;
  THEME_COLOR_PRIMARY: string;
  THEME_COLOR_PRIMARY_HOVER: string;
  THEME_COLOR_PRODUCT: string;
  THEME_COLOR_TEXT_PARENT: string;
  THEME_COLOR_HOVER: string;
  URL_KY_TUC_XA: string;
  TRA_SOAT_FROM_API: string;
  URL_CHANGE_PASSWORD: string;
  IS_DEMO: string;
  BANK_DEFAULT: string;
  FILEPATH_BASE_URL: string;
  ENABLE_FAST: string;
  ENABLE_FAKE: string;
  DEFAULT_PRINT_BIENLAI: string;
  CHO_PHEP_SUA_NGAY_THU: string;
  IS_SHOW_NOFITICATION: string;
}
export const appConst: IAppConst = {
  headerHeight: 56,
  baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? "",
  OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? "",
  OIDC_LOGOUT: process.env.REACT_APP_OIDC_LOGOUT?.toString() ?? "",
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? "",
  OIDC_CLIENT_SECRET:
    process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? "",
  OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? "",
  OIDC_UNIT: process.env.REACT_APP_OIDC_UNIT?.toString() ?? "",
  OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE?.toString() ?? "",
  URL_CHANGE_PASSWORD:
    process.env.REACT_APP_URL_CHANGE_PASSWORD?.toString() ?? "",

  MENU_PHAN_QUYEN: process.env.REACT_APP_MENU_PHAN_QUYEN?.toString() ?? "0",
  LOGO: process.env.REACT_APP_LOGO?.toString() ?? "",
  NAME_UNIT: process.env.REACT_APP_NAME_UNIT?.toString() ?? "",
  GOV_NAME: process.env.REACT_APP_GOV_NAME?.toString() ?? "",
  MAU_BIEN_LAI_SINH_VIEN:
    process.env.REACT_APP_BIEN_LAI_SINH_VIEN?.toString() ?? "03",
  MAU_BIEN_LAI_SINH_VIEN_NHAP_HOC:
    process.env.REACT_APP_BIEN_SINH_VIEN_NHAP_HOC?.toString() ?? "04",
  MAU_BIEN_LAI_THI_SINH_TUYEN_SINH:
    process.env.REACT_APP_BIEN_SINH_VIEN_TUYEN_SINH?.toString() ?? "05",

  //style
  THEME: process.env.REACT_APP_THEME?.toString() ?? "",
  THEME_COLOR_PRIMARY:
    process.env.REACT_APP_THEME_COLOR_PRIMARY?.toString() ?? "",
  THEME_COLOR_PRIMARY_HOVER:
    process.env.REACT_APP_THEME_COLOR_PRIMARY_HOVER?.toString() ?? "",
  THEME_COLOR_PRODUCT:
    process.env.REACT_APP_THEME_COLOR_PRODUCT?.toString() ?? "",
  THEME_COLOR_TEXT_PARENT:
    process.env.REACT_APP_THEME_COLOR_TEXT_PARENT?.toString() ?? "",
  THEME_COLOR_HOVER: process.env.REACT_APP_THEME_COLOR_HOVER?.toString() ?? "",

  URL_KY_TUC_XA: process.env.REACT_APP_URL_KY_TUC_XA?.toString() ?? "",
  TRA_SOAT_FROM_API: process.env.REACT_APP_TRA_SOAT_FROM_API?.toString() ?? "1",

  IS_DEMO: process.env.REACT_APP_IS_DEMO?.toString() ?? "0",
  BANK_DEFAULT: process.env.REACT_APP_BANK_DEFAULT?.toString() ?? "",
  FILEPATH_BASE_URL:
    process.env.REACT_APP_FILEPATH_BASE_URL?.toString() ?? "~/",
  ENABLE_FAST: process.env.REACT_APP_ENABLE_FAST?.toString() ?? "0",
  ENABLE_FAKE: process.env.REACT_APP_ENABLE_FAKE?.toString() ?? "0",
  DEFAULT_PRINT_BIENLAI:
    process.env.REACT_APP_DEFAULT_PRINT_BIENLAI?.toString() ?? "-1",
  CHO_PHEP_SUA_NGAY_THU:
    process.env.REACT_APP_CHO_PHEP_SUA_NGAY_THU?.toString() ?? "1",
  IS_SHOW_NOFITICATION:
    process.env.REACT_APP_IS_SHOW_NOFITICATION?.toString() ?? "0",
};
